module.exports = __webpack_public_path__ + "static/img/06.523a790.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wench/06.jpg
// module id = MtXz
// module chunks = 1